import {FC, memo, useEffect} from 'react'
import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {Selection} from '../../../components/Selection'
import {TextInputV2} from '../../../components/TextInputV2'
import {SECTOR_OPTIONS} from '../../../constants'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {
  resetFilter,
  resetFilterPOApproved,
  setFilterPOApproved as setFilter,
  setSelectedOrder,
  sipSelector,
} from '../../../redux/slices/sipSlices'
import {TOrder} from '../../../redux/types'
import Pagination from '../component/Pagination'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'

interface TableBrowseApprovedOrderProps {
  selectedOrderId?: string | number
  onSelectedOrder: (order: TOrder) => void
  paginateNumber: any
  numberUrls: any[]
  orderList?: any[]
  isLoading?: boolean
}

/**
 * Component yang menampilkan table approved order
 */
// eslint-disable-next-line react/display-name
export const TableBrowseApprovedOrders = memo((props: TableBrowseApprovedOrderProps) => {
  const {t} = useTranslation()
  const {filterPOApproved: filter} = useAppSelector(sipSelector)
  const dispatch = useAppDispatch()
  const {RowEmptyData, RowLoader} = useRowTable({
    colSpan: 4,
    onReloadTable: () => handleResetData(),
  })

  /**
   * Handler untuk menentukan order yang dipilih
   */
  const handleSelectedOrder = (order: TOrder) => {
    dispatch(setSelectedOrder(order))
    props.onSelectedOrder(order)
  }

  /**
   * Handler untuk reset data dan filter
   */
  const handleResetData = () => dispatch(resetFilter())

  /**
   * Reset filter on unmounted
   */
  useEffect(() => {
    return () => {
      dispatch(resetFilterPOApproved())
    }
  }, [dispatch])

  return (
    <TableUI.TableWrapper>
      <TableUI.Table>
        <TableUI.THead>
          <tr>
            <th align='center'></th>
            <th>{t('order-no')}</th>
            <th>{t('order-pembeli')}</th>
            <th>{t('Sektor')}</th>
          </tr>
        </TableUI.THead>

        <TableUI.TBody>
          <tr style={{backgroundColor: 'white'}}>
            <td></td>
            <td>
              <TextInputV2
                placeholder={t('order-no')}
                value={filter?.po_number ?? ''}
                onChange={({target}) => dispatch(setFilter({...filter, po_number: target.value}))}
              />
            </td>
            <td>
              <TextInputV2
                placeholder={t('order-pembeli')}
                value={filter?.customer_name ?? ''}
                onChange={({target}) =>
                  dispatch(setFilter({...filter, customer_name: target.value}))
                }
              />
            </td>
            <td>
              <Selection
                placeholder={t('Sektor')}
                data={SECTOR_OPTIONS}
                value={filter?.sector_id ?? ''}
                onChange={(sector_id) => dispatch(setFilter({...filter, sector_id}))}
              />
            </td>
          </tr>

          {props.isLoading ? (
            <RowLoader />
          ) : props?.orderList?.length === 0 ? (
            <RowEmptyData />
          ) : (
            props?.orderList?.map((item, index) => {
              return (
                <tr key={item?.id ?? index}>
                  <td>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <Form.Check
                        reverse
                        type='checkbox'
                        id={item?.customer?.customer_code ?? ''}
                        checked={props.selectedOrderId === item?.id}
                        onChange={() => handleSelectedOrder(item)}
                      />
                    </div>
                  </td>
                  <td>10{item.po_number}</td>
                  <td>
                    {item.customer?.title == null
                      ? item.customer?.name
                      : item.customer?.title + '-' + item.customer?.name}
                  </td>
                  <td>{t(item.sector?.name ?? '')}</td>
                </tr>
              )
            })
          )}
        </TableUI.TBody>
      </TableUI.Table>
      <div className='my-5'>
        <Pagination paginate={props.paginateNumber} test={props.numberUrls} />
      </div>
    </TableUI.TableWrapper>
  )
})
